export default __webpack_public_path__ + "static/media/bg.637e42cf.png";